// extracted by mini-css-extract-plugin
module.exports = {"info_container":"VerticalAlerts_info_container__19hX9"};